/* 
	Molly Lentz 7.20.18
	Adapted from: https://gomakethings.com/how-to-add-transition-animations-to-vanilla-javascript-show-and-hide-methods/
	on pageload:					var accountAccordions = new getAccordions4i();
	enable:  						accountAccordions.init();
	open/close are also available:  	accountAccordions.close(document.getElementById("SaleSection"));
	css needed: components/_accordion.scss
	see styelguide for HTML example
*/

var getAccordions4i = function(){
	let init = function (container){
		let accordionHdrs = container.querySelectorAll(".accordionHeader");
		accordionHdrs.forEach(header => {
			header.removeEventListener("click", togglePanel);
			header.addEventListener("click", togglePanel);
	  	});	
	},
	open = function (accordBtn) {
		let closedPanel = accordBtn,
		headerBtn = closedPanel.previousElementSibling.firstElementChild,
		getHeight = () => {
			closedPanel.style.display = "block";
			let height = closedPanel.scrollHeight + "px"; 
			closedPanel.style.display = ''; 
			return height;
		},
		height = getHeight();
		
		closedPanel.style.height = height; 
		closedPanel.classList.add("open"); 
		closedPanel.setAttribute("aria-hidden", "false");
		headerBtn.setAttribute("aria-expanded", "true");
	
		// This is important so content can scale responsively
		setTimeout(() => closedPanel.style.height = '', 300);
	},
	close = function (accordBtn) {
		let openPanel = accordBtn,
		headerBtn = openPanel.previousElementSibling.firstElementChild;
			
		// Give the element a height to change from
		openPanel.style.height = openPanel.scrollHeight + 'px';		
		openPanel.setAttribute("aria-hidden", "true");
		headerBtn.setAttribute("aria-expanded", "false");

		setTimeout(() => openPanel.style.height = '0', 1);
		setTimeout(() => openPanel.classList.remove("open"), 300);
	},
	openAll = function(container){
		let specificAccordHeaders = container.querySelectorAll(".accordionHeader");
		specificAccordHeaders.forEach(header => {
	    		let accordionPanel = header.parentNode.nextElementSibling;
			open(accordionPanel);
	  	});			
	},
	closeAll = function(container){
		let specificAccordHeaders = container.querySelectorAll(".accordionHeader");
		specificAccordHeaders.forEach(header => {
	    		let accordionPanel = header.parentNode.nextElementSibling;
			close(accordionPanel);
	  	});		
	},
	/*firstLinkFocus = function(el){
		// a11y commented out because they to not recommend shifting focus on open
		// important to add "disabled" text to hidden inputs in order to not collect them here
		let thisPanel = el;
		let focusableEls = thisPanel.querySelectorAll('a, button:not([disabled]), [href], .close4iDialog, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
		
		if(focusableEls[0] !== undefined){
			focusableEls[0].focus();
		}
	},*/
	togglePanel = function (e) {
		e.preventDefault();
		//e.stopImmediatePropagation(); //this works to prevent noibu event from running on headers on list page but is icky
		let accordionPanel = e.currentTarget.parentNode.nextElementSibling;
				
		if (accordionPanel.classList.contains("open")) {
			close(accordionPanel);
			return;
		}else {
			open(accordionPanel);
		}
	};
	
	return {
		init: init,
		close: close,
		open: open,
		openAll: openAll,
		closeAll: closeAll
	};
};